/* eslint-disable no-control-regex */

export const EMAIL_REGEX =
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

export const VISA_REGEX = /^4[0-9]{12}(?:[0-9]{3})?$/
export const MASTER_REGEX = /^5[1-5][0-9]{14}$/
export const AMEX_REGEX = /^3[47][0-9]{13}$/
export const JCB_REGEX = /^(?:2131|1800|35\d{3})\d{11}$/

export const CARDS_REGEX = [VISA_REGEX, MASTER_REGEX, AMEX_REGEX, JCB_REGEX]

// FORMAT MM/YY
export const EXPIRY_DATE_REGEX = /^(?:0[1-9]|1[0-2])\/(?:0|[2-9][0-9])$/

// FORMAT MM/YYYY
export const EXPIRY_DELIVERY_DATE_REGEX = /^(0[1-9]|1[0-2])\/\d{4}$/

// FORMAT 111 OR 1111
export const CVV_REGEX = /^[0-9]{3,4}$/

/*
This regular expression checks the following:

1. It validates strings composed of one or more words. Words must be separated by one or more spaces.
2. Each word must follow specific rules:
   a. Characters allowed in the word:
      - Upper and lower case letters of the Spanish alphabet, including accented vowels and the letter "Ñ".
   b. Allowed symbols:
      - Apostrophe (') and hyphen (-). These symbols may appear a maximum of once per word.
   c. Word structure:
      - Must begin and end with a letter. If the word were allowed to begin or end with symbols, the quantifier '+' would be changed to '*', thus allowing zero or more occurrences of letters or symbols at the beginning or end of the word.
*/
export const FULLNAME_REGEX =
  /^([A-Za-zÑñÁáÉéÍíÓóÚú]+['\-]{0,1}[A-Za-zÑñÁáÉéÍíÓóÚú]+)(\s+([A-Za-zÑñÁáÉéÍíÓóÚú]+['\-]{0,1}[A-Za-zÑñÁáÉéÍíÓóÚú]+))*$/

export const REGEX_HAS_SPECIAL_CHARACTER =
  /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/

export const REGEX_HAS_UPPERCASE_CHARACTER = /[A-Z]/

export const REGEX_HAS_LOWERCASE_CHARACTER = /[a-z]/

export const REGEX_HAS_NUMBER_CHARACTER = /[0-9]/
